import {
  EditExtSourceData,
  MetricExternalSourceRow,
} from './types';

export type BuildEditExtSourceDataInput = {
  storedSourceData: EditExtSourceData | Record<string, unknown> | null | undefined;
  automateTargetFlag: boolean;
  kpiDataIdFallback?: string;
};

/** Parse `metric_external_sources.data` (object or JSON string) for edit save. */
export function parseMetricExternalSourceData(
  data: MetricExternalSourceRow['data'],
): EditExtSourceData | Record<string, unknown> {
  if (typeof data === 'string') {
    try {
      return JSON.parse(data) as EditExtSourceData;
    } catch {
      return {};
    }
  }
  if (data && typeof data === 'object') {
    return data as EditExtSourceData;
  }
  return {};
}

/** Build `ext_source_data` for KR edit save (legacy + v2 marketplace). */
export function buildEditExtSourceData(input: BuildEditExtSourceDataInput): EditExtSourceData {
  const stored =
    input.storedSourceData && typeof input.storedSourceData === 'object'
      ? input.storedSourceData
      : {};

  const externalData: EditExtSourceData = {
    ...stored,
    automateTargetFlag: input.automateTargetFlag,
  };

  if (input.kpiDataIdFallback && !externalData.kpiDataId) {
    externalData.kpiDataId = input.kpiDataIdFallback;
  }

  return externalData;
}

/** Mirror edit UI: stringify `external_app_sources.data` when the row stored an object. */
export function buildExternalSourceForPayload(
  currentExternalSource: MetricExternalSourceRow,
  externalData: EditExtSourceData,
): MetricExternalSourceRow {
  return {
    ...currentExternalSource,
    data:
      typeof currentExternalSource.data === 'object'
        ? JSON.stringify(externalData)
        : externalData,
  };
}
